import HttpKit from '@/utils/http-kit'
export default {
  // 列表
  tenList(data) {
    return HttpKit.post('/api/portalCli/tender/inteList',
      data
    ).then(
      res => res.data
    )
  },
  // 详情
  tenDet(data) {
    return HttpKit.post('/api/portalCli/tender/inteDetail',
      data
    ).then(
      res => res.data
    )
  },
  // 详情相关公告
  getNoticeNavigationList(data) {
    return HttpKit.post('/api/portalCli/tender/getNoticeNavigationList',
      data
    ).then(
      res => res.data
    )
  },
  // 通知公告
  announce (data) {
    return HttpKit.post('/api/portalCli/announce', data).then(
      res => res.data
    )
  },
  // 通知公告详情
  announceDet (data) {
    return HttpKit.post('/api/portalCli/announce/detail', data).then(
      res => res.data
    )
  },
  // 通知公告
  getPortalAnnounce (data) {
    return HttpKit.post('/api/portalCli/announce/portal', data).then(
      res => res.data
    )
  },
}



// WEBPACK FOOTER //
// ./src/api/tender.js